import React from 'react'
import Card from '@mui/material/Card';
import Typography from "@mui/material/Typography";

export default function Participants({
    confbridgeChannels, 
    confbridgeChannelAvatars,
    confbridgeTalkingStatus, 
}) {
  return (
    <div className='live-call-participants'>
        {confbridgeChannels.map(channel => {
            if (channel.caller?.name === "MODERATOR") return null// hide moderators from list
            return (
                <Card 
                    key={channel.id}
                    sx={{ width: '100%'}}
                >
                    <div className='live-call-participant'>
                        {confbridgeChannelAvatars.get(channel.id)}
                        <Typography
                            color={confbridgeTalkingStatus.get(channel.id) ? 'primary' : null}
                        >
                            {channel.caller.name}
                        </Typography>
                    </div>
                </Card>
            )
        })}
    </div>
  )
}
